import {
  UPDATE_PASSWORD_FAILURE,
  UPDATE_PASSWORD_SUCCEEDED,
  WRONG_CURRENT_PASSWORD,
  CLEAR_STATE
} from './types';

const INITIAL_STATE = {
  passwordUpdated: false,
  passwordUpdateError: ''
};

export default function(state = INITIAL_STATE, action) {
  if (
    action.type === UPDATE_PASSWORD_FAILURE ||
    action.type === WRONG_CURRENT_PASSWORD
  ) {
    return {
      ...state,
      passwordUpdateError: action.payload,
      passwordUpdated: false
    };
  } else if (action.type === UPDATE_PASSWORD_SUCCEEDED) {
    return { ...state, passwordUpdated: true, passwordUpdateError: '' };
  } else if (action.type === CLEAR_STATE) {
    return { ...state, passwordUpdated: false, passwordUpdateError: '' };
  } else {
    return state;
  }
}
